import { useRef, useState } from "react";
import "./styleH.css";
const HorizontalScroll = ({ children, widthVal }) => {
  const elementRef = useRef(null);
  const [arrowPreDisable, setArrowPreDisable] = useState(true);
  const [arrowNextDisable, setArrowNextDisable] = useState(false);

  const handleButtonState =()=>{
    const { scrollLeft, scrollWidth, clientWidth } = elementRef.current;
    if (scrollLeft+clientWidth >= scrollWidth) {
      setArrowNextDisable(true);
      
    } else if (scrollLeft <= 0) {
      setArrowPreDisable(true);
    } else {
      setArrowPreDisable(false);
      setArrowNextDisable(false);
    }
  }
  const handleHorizantalScroll = (element, speed, distance, step) => {
    
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      element.scrollLeft += step;
      scrollAmount += Math.abs(step);
      if (scrollAmount >= distance) {
        clearInterval(slideTimer);
      }
      
      handleButtonState()
    }, speed);
  };

  return (
    <>
      <div className="container-hscroll-outer">
        {/* <div className="prev-hscroll-button"
      onClick={() => {
        handleHorizantalScroll(elementRef.current, 25, 100, -10);
      }}
      >
      &#9664;
    </div>
    
    <div className="next-hscroll-button"
    onClick={() => {
      handleHorizantalScroll(elementRef.current, 25, 100, 10);
    }}
    >
      &#9654;
    </div> */}
        <a
        className={`prevbtn ${arrowPreDisable? 'hidden':''}`}
          onClick={() => {
            handleHorizantalScroll(elementRef.current, 25, 100, -10);
          }}
        >
          &#10094;
        </a>
        <a
          className={`nextbtn ${arrowNextDisable? 'hidden':''}`}
          onClick={() => {
            handleHorizantalScroll(elementRef.current, 25, 100, 10);
          }}
        >
          &#10095;
        </a>

        <div
          className="container-hscroll-inner example"
          style={{ maxWidth: widthVal }}
          ref={elementRef}
          onScroll={handleButtonState}
        >
          {/* <div className="flex-start nowrap"
     > {children}</div> */}
          {children}
        </div>
      </div>
    </>
  );
};
export default HorizontalScroll;
